import { useMemo } from 'react';

import { getTranslatedValue } from 'common/utils/translationUtils';

import { useSelectedCountry } from './useSelectedCountry';
import { Translation } from '../api-types/common';

export function useSelectedCountryTranslatedValue(translations: Translation[]) {
  const { data: country } = useSelectedCountry();

  return useMemo(
    () => getTranslatedValue(translations, country?.defaultLanguageCode),
    [translations, country],
  );
}
